import React, { createContext, useContext } from "react";

const MessengerContext = createContext();
const log = window.require("electron-log");

export default class MessengerProvider extends React.Component {
  componentWillUnmount = async () => {
    const { messenger } = this.props;
    try {
      await messenger.stop();
    } catch (err) {
      log.error(err);
    }
  };

  render() {
    return (
      <MessengerContext.Provider value={this.props.messenger}>
        {React.Children.only(this.props.children)}
      </MessengerContext.Provider>
    );
  }
}

export function withMessenger(Component) {
  return (props) => {
    return (
      <MessengerContext.Consumer>
        {(messenger) => <Component messenger={messenger} {...props} />}
      </MessengerContext.Consumer>
    );
  };
}

export const useMessenger = () => useContext(MessengerContext);
